import React from "react";
import { Icon } from "@iconify/react";

const RealTimeComponent = () => {
    return (
        <div className="md:h-screen flex items-center w-11/12">
            <div>
                <h2 className="text-[#036F36] text-lg md:text-xl lg:text-3xl mb-3">
                    Real-Time Policy Tracking
                </h2>
                <p className="text-lg md:text-xl lg:text-2xl">
                    Stay ahead with real-time insights on policy development - from initiation to implementation. See which policies are in progress, which have been approved, and which are driving real change across agri-food systems. Empower your decisions with full visibility at every stage.
                </p>
                <a href="/home-tracker">
                    <button className="common-button mt-3 ml-0 text-base md:text-lg lg:text-xl">
                        Reveal the Journey
                        <Icon icon="maki:arrow" width="12" height="12" className="ml-2"/>
                    </button>
                </a>
            </div>
        </div>
    );
};

export default RealTimeComponent;